var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgButtonsClose(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#373837;}.b{fill:#f8f8f8;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.094 9.793)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 17,
    cy: 17,
    r: 17,
    transform: "translate(0.094 -9.793)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-10.748-21.5,4.261-6.493a1.238,1.238,0,0,0,.6.334,1.562,1.562,0,0,0,.7.007,1.113,1.113,0,0,0,.605-.355,1.239,1.239,0,0,0,.355-.6,1.387,1.387,0,0,0,0-.7,1.289,1.289,0,0,0-.341-.605L-8.828-23.422a1.383,1.383,0,0,0-.612-.341,1.413,1.413,0,0,0-.7-.007,1.228,1.228,0,0,0-.612.362,1.193,1.193,0,0,0-.348.605,1.412,1.412,0,0,0,.007.7A1.385,1.385,0,0,0-10.748-21.5Zm0,13.089a1.289,1.289,0,0,0-.341.6,1.44,1.44,0,0,0-.007.7,1.193,1.193,0,0,0,.348.605,1.183,1.183,0,0,0,.612.355,1.532,1.532,0,0,0,.7-.007,1.326,1.326,0,0,0,.612-.334L6.18-21.5a1.385,1.385,0,0,0,.341-.605,1.36,1.36,0,0,0,0-.7,1.238,1.238,0,0,0-.355-.605,1.153,1.153,0,0,0-.605-.362,1.44,1.44,0,0,0-.7.007,1.289,1.289,0,0,0-.6.341Z",
    transform: "translate(18.824 21.863)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonsClose);
export default __webpack_public_path__ + "static/media/Buttons-Close.f725e7ef21753386ae75d532b0fa617a.svg";
export { ForwardRef as ReactComponent };